import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Stack, Tab, Tabs, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ButtonBadge, TabBadge } from '../../Forms/Advanced Properties/AdvancedProperties'
import { useTranslation } from 'react-i18next';
import { lgDocPath } from '../../../../constants/languageDocPaths';
import { useSelector } from 'react-redux';
import Split from "react-split";
import { BallotOutlined } from '@mui/icons-material';
import TabPanel from '../../../TabPanel';
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild';

function GetDataAdvanceProperties({ updateAdvProp, disableControl }) {
    const { t } = useTranslation();
    const { baseUrl, lang } = useSelector((state) => state.queryParams);
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector(state => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;

    const [advancePropsCount, setAdvancePropsCount] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [currTab, setCurrTab] = useState(0);
    const [minFileAge, setMinFileAge] = useState('');
    const [maxFileAge, setMaxFileAge] = useState('');
    const [sortBy, setSortBy] = useState(t('FILENAME'));
    const [sortOrder, setSortOrder] = useState(t('ASC'))
    const [plugin, setPlugin] = useState('');
    const [content, setContent] = useState({})
    const sortByDropdown=[{text:'FILENAME', value:'File Name'}, {text:'FILE_DATE', value:'File Date'}, {text:'FILE_SIZE', value:'File Size'}];
    const sortOrderDropdown=[{text:'ASC', value:'ASC'},{text:'DESC', value:'DESC'}];
    const sortByOptions = sortByDropdown.map((e,i) => (
      <MenuItem value={e.value} key={`${e.value}-${i}`}>
         {t(e.text)}
      </MenuItem>
    ))
    const sortOrderOptions = sortOrderDropdown.map((e,i) => (
      <MenuItem value={e.value} key={`${e.value}-${i}`}>
         {t(e.text)}
      </MenuItem>
    ))
    const handleChange = (value, setState, key) => {
        setState(value);
        setContent((prev) => {
         return { ...prev, [key]: value}
        })
    }
    const handleOkClick = () => {
       setAdvancePropsCount(1);
       if(Object.keys(content).length > 0) updateAdvProp({ add:{...content} });
       setOpenModal(false)
    }
    const handleClearClick = () => {
      setContent({})
      setAdvancePropsCount(0)
      const modifyProps = {FILETIME_FILTER: null, FILETIME_FILTER_MAX: null, SORT_BY: null, SORT_ORDER: null, FILE_FILTER_PLUGIN: null}
      updateAdvProp({ remove: modifyProps });
      setOpenModal(false)
    }
    useEffect(() => {
      if(selectedNode?.INBOUND){
         const { FILETIME_FILTER, FILETIME_FILTER_MAX, SORT_BY, SORT_ORDER, FILE_FILTER_PLUGIN  } = selectedNode?.INBOUND
         setMinFileAge(FILETIME_FILTER || '');
         setMaxFileAge(FILETIME_FILTER_MAX || '');
         setSortBy(SORT_BY || 'File Name');
         setSortOrder(SORT_ORDER || 'ASC');
         setPlugin(FILE_FILTER_PLUGIN || '');

         if (FILETIME_FILTER || FILETIME_FILTER_MAX || SORT_BY || SORT_ORDER || FILE_FILTER_PLUGIN) {
            setAdvancePropsCount(1);
          } else {
            setAdvancePropsCount(0)
          }
      }
    },[selectedNode?.INBOUND, openModal])
  return (
    <>
     <ButtonBadge badgeContent={advancePropsCount} color='primary'>
        <Button size='small' fullWidth variant='outlined' onClick={() => setOpenModal(true)} disabled={disableControl || false}>
        {t("BTN_ADV_PROPERTIES")} {advancePropsCount > 0 ? `(${t('SET')})` : ''}
        </Button>
     </ButtonBadge>
     <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth='lg'>
        <DialogTitle style={{ borderBottom: "1px solid #e0e0e0" }}>
            <div className="title">{t("TIT_ADV_PROP_DIALOG")}</div>
        </DialogTitle>
        <DialogContent className='dialog-content' sx={{ boxSizing: "border-box", height:'80vh', overflow: 'hidden'}}>
            <Split
             className='split height-100 flex'
             style={{ gap: '4px'}}
             direction='horizontal'
             gutterSize={4}
             snapOffset={0}
             minSize={100}
             sizes={[35, 65]}
            >
             <Grid item xs={6}>
                <iframe className='docFrame' title='adavance-properties-help' src={`${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/adv_getdata_properties.html`} />
             </Grid>
             <Grid item xs={8}>
               <Box style={{boxSizing:'border-box',height:'100%', border:'1px solid #e0e0e0', borderRadius:'5px'}}>
                  <Box sx={{border: 1, borderColor:'divider'}}>
                     <Tabs sx={{backgroundColor:'#fff', display:'flex'}} value={currTab}>
                        <Tab sx={{ flex: 1}} label={
                           <TabBadge badgeContent={advancePropsCount} color='primary'>
                              <div className='flex align-start' style={{ width: '100%'}}>
                                 <BallotOutlined size='small' className='margin-right-4' />
                                 <span style={{marginTop: '3px'}}>
                                    {t('LBL_GET_DATA_PROPERTIES')}
                                 </span>
                              </div>
                           </TabBadge>
                        } />
                     </Tabs>
                  </Box>
                  <div style={{height: 'calc(100% -34px)', boxSizing: 'border-box', overflow:'auto'}}>
                     <Box className='height-100-tab width-100'>
                        <TabPanel className='height-100 width-100' value={currTab} index={0}>
                           <div className='padding-16'>
                              <Stack spacing={"15px"} marginTop="15px">
                              <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'5px'}}>
                                 <TextField 
                                 className='width-100'
                                 size='small'
                                 sx={{flex:2}} 
                                 variant='outlined' 
                                 label={t('LBL_TIME_GRT')} 
                                 value={minFileAge}
                                 onChange={(e) => handleChange(e.target.value, setMinFileAge, 'FILETIME_FILTER')} />
                                 <p>
                                    {t('LBL_TIME_MAX2')}
                                 </p>
                              </div>
                              <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'5px'}}>
                                 <TextField 
                                 className='width-100'
                                 size='small'
                                 sx={{flex:2}} 
                                 variant='outlined' 
                                 label={t('LBL_TIME_MAX')} 
                                 value={maxFileAge}
                                 onChange={(e) => handleChange(e.target.value, setMaxFileAge, 'FILETIME_FILTER_MAX')} />
                                 <p>
                                    {t('LBL_TIME_MAX2')}
                                 </p>
                              </div>
                              <div style={{display:'flex', gap:'3px', justifyContent:'center', alignItems:'center'}}>
                                 <FormControl className='width-100'>
                                    <InputLabel>{t('LBL_SORTBY')}</InputLabel>
                                    <Select 
                                    size='small'
                                    sx={{flex:1}}
                                    value={sortBy}
                                    label={t('LBL_SORTBY')}
                                    onChange={(e) => handleChange(e.target.value, setSortBy, 'SORT_BY')}>
                                       {sortByOptions}
                                    </Select>
                                 </FormControl>
                                 <FormControl className='width-100'>
                                    <InputLabel>{'Sort Order:'}</InputLabel>
                                    <Select 
                                    size='small' 
                                    sx={{flex:1}}
                                    value={sortOrder}
                                    label={'Sort Order:'}
                                    onChange={(e) => handleChange(e.target.value, setSortOrder, 'SORT_ORDER')}>
                                       {sortOrderOptions}
                                    </Select>
                                 </FormControl>
                                 
                              </div>
                              <TextField 
                                 className='width-100'
                                 size='small'
                                 variant='outlined' 
                                 label={t('TIT_PLUGIN')} 
                                 value={plugin}
                                 onChange={(e) => handleChange(e.target.value, setPlugin, 'FILE_FILTER_PLUGIN')} />
                              </Stack>
                           
                              
                           </div>
                        </TabPanel>
                     </Box>
                  </div>
               </Box>
             </Grid>
            </Split>
        </DialogContent>
        <DialogActions>
         <Box>
            <Box sx={{display:'flex', gap:'10px'}}>
               <Button variant='outlined' size='small' onClick={handleClearClick}>
                  {t("BTN_CLEAR_ADVANCED_PROPS")}
               </Button>
               <Button variant='outlined' size='small' onClick={handleOkClick}>
                  {t('BTN_OK')}
               </Button>
               <Button variant='outlined' size='small' onClick={() => setOpenModal(false)}>
                  {t('BTN_CANCEL')}
               </Button>
            </Box>
         </Box>
        </DialogActions>
     </Dialog>
    </>
  )
}

export default GetDataAdvanceProperties